import {List} from '../../../../design-system/atoms/List/List';
import {CommonGroupProps} from '../../type';

export function MainRankingNormalList({children}: CommonGroupProps) {
  return (
    <List direction="column" gapPx={0} className="w-full">
      {children}
    </List>
  );
}
